export default "__VITE_ASSET__Dl24VlMn__"